import type { TypeInventoryLocationSummary } from '../../../types/User'

export type InventoryLocationOption = {
  id: number
  name: string
  is_active?: boolean
}

const LOCK_INVENTORY_LOCATION_FIELDS_KEYS = [
  'lock_inventory_location_fields',
  'lock-inventory-location-fields',
] as const

const getConfigValue = (value: unknown): unknown => {
  if (value && typeof value === 'object' && 'value' in value) {
    return (value as { value: unknown }).value
  }

  return value
}

const configValueIsTrue = (value: unknown): boolean => {
  const unwrapped = getConfigValue(value)
  if (unwrapped === true || unwrapped === 1) return true
  if (typeof unwrapped === 'string') {
    const normalized = unwrapped.trim().toLowerCase()
    return normalized === 'true' || normalized === '1'
  }

  return false
}

export const shouldLockInventoryLocationFields = (inventoryConfigs: Record<string, unknown>): boolean =>
  LOCK_INVENTORY_LOCATION_FIELDS_KEYS.some((key) => configValueIsTrue(inventoryConfigs[key]))

export const getActiveInventoryLocationOption = (
  activeLocation?: TypeInventoryLocationSummary | null,
): InventoryLocationOption | null => {
  if (!activeLocation || !Number.isFinite(Number(activeLocation.id))) return null

  return {
    id: Number(activeLocation.id),
    name: activeLocation.name,
    is_active: activeLocation.is_active,
  }
}

export const ensureLocationOption = (
  locations: InventoryLocationOption[],
  location: InventoryLocationOption | null,
): InventoryLocationOption[] => {
  if (!location) return locations
  if (locations.some((option) => Number(option.id) === Number(location.id))) return locations

  return [...locations, location]
}
